import health from "../desktop/health";
import emergency from "../desktop/emergency";
import finddocCare from "../desktop/finddoc-care";

const localeUrlPrefix = '';
const wpUrlPrefixWithLocale = 'health';
export default (cms) => [
    {
        heading: '搜尋醫生',
        items: [
            {
                name: '新冠病毒檢測',
                href: 'https://www.finddoc.com/covid19?itm_source=nav_item&itm_medium=%E6%96%B0%E5%86%A0%E7%97%85%E6%AF%92%E6%AA%A2%E6%B8%AC&itm_campaign=covid-test_2020"',
            },
            { name: '視像問診', href: `${localeUrlPrefix}/vc` },
            { name: '專科醫生搜尋', href: `${localeUrlPrefix}/specialties` },
            { name: '香港醫生集中地', href: `${localeUrlPrefix}/buildings` },
            { name: '香港醫院名單', href: `${localeUrlPrefix}/hospital-affiliations` },
            { name: '香港診所名單', href: `${localeUrlPrefix}/practices` },
        ],
        isCollapsible: false, 
    },
    {
        heading: '健康學堂',
        items: [
            {
                name: '旅遊氣泡懶人包',
                href: 'https://www.finddoc.com/health/guides/%E6%97%85%E9%81%8A%E6%B0%A3%E6%B3%A1%E6%87%B6%E4%BA%BA%E5%8C%85/?itm_source=nav_item&itm_medium=%E6%97%85%E9%81%8A%E6%B0%A3%E6%B3%A1%E6%87%B6%E4%BA%BA%E5%8C%85&itm_campaign=covid-test_2020',
            },
            {
                name: '健康碼懶人包',
                href: 'https://www.finddoc.com/health/guides/%E5%81%A5%E5%BA%B7%E7%A2%BC%E6%87%B6%E4%BA%BA%E5%8C%85/?itm_source=nav_item&itm_medium=%E5%81%A5%E5%BA%B7%E7%A2%BC%E6%87%B6%E4%BA%BA%E5%8C%85&itm_campaign=covid-test_2020',
            },
            { name: 'FindDocTV', href: `${wpUrlPrefixWithLocale}/finddoctv/` },
            { name: '健康指南', href: `${wpUrlPrefixWithLocale}/guides/` },
            { name: '醫生話你知', href: `${wpUrlPrefixWithLocale}/doctors-blog/` },
            { name: '最新內容', href: `${wpUrlPrefixWithLocale}/news/` },
        ],
        isCollapsible: false,
    },
    {
        heading: '網購優質醫療產品',
        items: [
            { name: 'FindDoc Club', href: `${localeUrlPrefix}/club` },
        ],
        isCollapsible: false,
    },
    {
        heading: '健康小測試',
        isCollapsible: true,
        items: (health(cms).children as any).filter(x => x.id === 'self-tests')[0].children.map(x => ({ name: x.name, href: x.href })),
    },
    {
        heading: emergency.name,
        isCollapsible: true,
        items: Array.prototype.concat.apply([], emergency.children.map(x => x.children)),
    },
    {
        heading: finddocCare.name,
        isCollapsible: false,
        items: [
            { name: 'FindDoc Care', href: `${localeUrlPrefix}/patient-care` },
        ],
    },
    {
        heading: '關於 FindDoc',
        isCollapsible: true,
        items: [
            { name: '關於我們', href: `${localeUrlPrefix}/about` },
            { name: '聯絡我們', href: `${localeUrlPrefix}/contact` },
            { name: '加入 FindDoc', href: `${localeUrlPrefix}/careers` },
            { name: '私隱政策', href: `${localeUrlPrefix}/privacy` },
            { name: '使用條款', href: `${localeUrlPrefix}/terms` },
        ],
    },
];